<template>
  <div class="pageDiv">
    <v-card class="no-login" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Club Players Admin</span>
      </v-card-title>

      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Club Players Admin ({{displayPlayers.length}})</span>
      </v-card-title>

      <v-card-text>
        <v-card-text>
          <input type="checkbox" style="width:20px;height:20px" @click="showMembers=!showMembers;updateList();"> Members Only
        </v-card-text>
        <v-card-text>
          <input class="input-text" @keypress="processKey($event)" type="text" v-model="searchTxt" style="width:160px">
          <v-btn class="primary-btn" @click="updateList()" style="margin-left:20px;">Search</v-btn>
          <v-btn class="primary-btn" @click="searchTxt='';displayPlayers=memberPlayers;" style="margin-left:20px;">Clear</v-btn>

          <a href="/api/players-csv" style="display:inline-block;margin-left:20px">
            PRINT CSV
          </a>
        </v-card-text>
      </v-card-text>

      <v-card class="player-div" v-for="(memberPlayer, index) in displayPlayers" :key="memberPlayer.playerId">
        <div class="player-card">
          <div class="actions-card">
            <div class="actionBtns">
              <a class="btnAction" @click="save(memberPlayer.player)"><span class="label16">Save</span></a>
              <a class="btnAction" @click="edit(memberPlayer.player)"><span class="label16">Edit</span></a>
              <a class="btnAction" @click="remove(memberPlayer.player)"><span class="label16">Delete</span></a>
            </div>
          </div>

          <div style="display: inline-block;">
            <div class="player-subcard">
              <div class="player-image-div">
                <v-img id="player-image-id" class="player-img" :src="'/images/players/' + memberPlayer.player.photoName">
                </v-img>

                <v-img class="member-logo" v-if="memberPlayer.membership" src="../../assets/img/dfwvga-logo-mini.png">
                </v-img>

                <input id="choose-playerfile-id" type="file"
                       @change="handleFileUpload($event, memberPlayer)"/><br>
                <v-btn class="primary-btn"
                       v-if="showButton && selectPlayerId === memberPlayer.player.playerId"
                       style="margin-top:10px;"
                       v-on:click="uploadPlayerImaged(memberPlayer, index)">Upload</v-btn>
              </div>
            </div>

            <div class="player-subcard">
              <span class="label12">Name: </span>
              {{memberPlayer.player.firstName}} {{memberPlayer.player.middleName}} {{memberPlayer.player.lastName}}<br>
              <span class="label12">ID: </span> {{memberPlayer.player.playerId}}<br>
              <span class="label12">UserId: </span> {{memberPlayer.player.userid}}<br>
              <span class="label12">Email: </span> {{memberPlayer.player.email}}<br>
              <span class="label12">Cell: </span> {{memberPlayer.player.cell}}<br>
            </div>

            <div class="player-subcard">
              <div class="player-content">
                <span class="label12">HCP: </span>
                <input class="input-text" type="text" v-model="memberPlayer.player.handicap">
              </div>

              <div class="player-content">
                <span class="label12">Role: </span>
                <select class="dropdown" v-model="memberPlayer.player.role">
                  <option value="USER">USER</option>
                  <option value="ADMIN">ADMIN</option>
                </select>
              </div>

              <div class="player-content">
                <span class="label12">Flight: </span>
                <select class="dropdown" v-model="memberPlayer.player.defaultFlight">
                  <option value="Nicklaus">Nicklaus</option>
                  <option value="Palmer">Palmer</option>
                  <option value="Hogan">Hogan</option>
                  <option value="Women">Women</option>
                </select>
              </div>

              <div class="player-content">
                <span class="label12">Photo: </span>
                <input class="input-text" style="width:160px;" type="text" v-model="memberPlayer.player.photoName">
              </div>
            </div>

            <div class="player-subcard">
              <div class="player-content">
                <span class="label12">Shirt Size: </span>
                <select class="dropdown" v-model="memberPlayer.player.shirtSize">
                  <option value="Select Size">Select Size</option>
                  <option value="X-Small">X-Small</option>
                  <option value="Small">Small</option>
                  <option value="Medium">Medium</option>
                  <option value="Large">Large</option>
                  <option value="X-Large">X-Large</option>
                </select>
              </div>

              <div class="player-content">
                <span class="label12">Member: </span>
                <input class="checkbox" type="checkbox" v-model="memberPlayer.membership" @change="membershipChange(memberPlayer)">
              </div>

              <div class="player-content">
                <span class="label12">No TC: </span>
                <select class="dropdown" v-model="memberPlayer.player.excludeTc" @change="excludeTcChange(memberPlayer)">
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>

              <div class="player-content">
                <span class="label12">Password: </span>
                <input class="input-text" type="text" style="width:160px;" v-model="memberPlayer.player.password">
              </div>
            </div>

            <div class="player-subcard">
              <div class="player-content">
                <span class="label12">Is Junior: </span>
                <select class="dropdown" v-model="memberPlayer.player.isJunior">
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
              <div class="player-content">
                <span class="label12">Is Senior: </span>
                <select class="dropdown" v-model="memberPlayer.player.isSenior">
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
              <div class="player-content">
                <span class="label12">Proximity: </span>
                <select class="dropdown" v-model="memberPlayer.player.proximity">
                  <option value="">None</option>
                  <option value="EAST">EAST</option>
                  <option value="WEST">WEST</option>
                </select>
              </div>
              <div class="player-content" v-if="$AuthSvc.isFw()">
                <span class="label12">Is FW: </span>
                <select class="dropdown" v-model="memberPlayer.player.isFw">
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-card>
  </div>
</template>

<script>
  import swal from 'sweetalert';

    export default {
      name: "login",
      data: () => ({
        count: 0,
        showPassword: false,
        memberPlayers: [],
        displayPlayers: [],
        selectPlayerId: -1,
        searchTxt: '',
        file: null,
        showButton: false,
        showMembers: false
      }),
      mounted: function() {
        this.loadPlayers();
      },
      methods: {
        loadPlayers() {
          var _this = this;

          this.axios.get('/admin/players')
          .then(function (response) {
              _this.memberPlayers = response.data;
              _this.displayPlayers = response.data;
              for(var i=0; i < _this.displayPlayers.length; i++) {
                _this.displayPlayers[i].match = true;
              }
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
        },
        remove: function(player) {
          var _this = this;

          swal({
              title: "Are you sure?",
              text: "Delete " + player.firstName + " " + player.lastName + "? You cannot recover!",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            })
            .then((willDelete) => {
              if (willDelete) {
                this.axios.delete('/admin/players/' + player.playerId)
                .then(function (response) {
                   console.log("RESPONSE: " + response.data);
                   swal({
                        title: "Success!",
                        text: "Player deleted.",
                        type: "success"
                    }).then(function() {
                        _this.loadPlayers();
                    });
                })
                .catch(function (error) {
                    swal("Error", "Player cannot be removed.", "error");
                });
              }
            });
        },
        processKey(event) {
          if (event.keyCode === 13) {
            this.updateList();
          }
        },
        updateList() {
          if (this.searchTxt !== null && this.searchTxt.length > 0) {
            this.displayPlayers = new Array();
            for(var i=0; i < this.memberPlayers.length; i++) {
              this.memberPlayers[i].match = false;
              var fname = this.memberPlayers[i].player.firstName.toLowerCase();
              var lname = this.memberPlayers[i].player.lastName.toLowerCase();
              var text = this.searchTxt.toLowerCase();
              if (fname.startsWith(text) || lname.startsWith(text)) {
                if (!this.showMembers) {
                  this.displayPlayers.push(this.memberPlayers[i]);
                }
                else {
                  if (this.memberPlayers[i].membership) {
                    this.displayPlayers.push(this.memberPlayers[i]);
                  }
                }
              }
            }
          }
          else {
            this.displayPlayers = new Array();
            for(var i=0; i < this.memberPlayers.length; i++) {
              if (!this.showMembers) {
                this.displayPlayers.push(this.memberPlayers[i]);
              }
              else {
                if (this.memberPlayers[i].membership) {
                  this.displayPlayers.push(this.memberPlayers[i]);
                }
              }
            }
          }

          console.log('Search: ' + this.searchTxt);
        },
        edit: function(player) {
          window.location.href = '/profile?id=' + player.playerId;
        },
        membershipChange(memberPlayer) {
          if (memberPlayer.membership) {
            this.axios.post('/admin/member/' + this.$AuthSvc.getYear() + '/' + memberPlayer.playerId)
            .then(function (response) {
              console.log("SUCCESS: " + response.data);
            })
            .catch(function (error) {
              console.log('ERROR: ' + error);
            });
          } else {
            this.axios.delete('/admin/member/' + this.$AuthSvc.getYear() + '/' + memberPlayer.playerId)
            .then(function (response) {
              console.log("SUCCESS: " + response.data);
            })
            .catch(function (error) {
              console.log('ERROR: ' + error);
            });
          }
        },
        excludeTcChange(memberPlayer) {
          if (memberPlayer.player.excludeTc==='Y') {
            this.axios.post('/admin/exclude-tc/'+memberPlayer.playerId)
            .then(function (response) {
              console.log("SUCCESS: " + response.data);
            })
            .catch(function (error) {
              console.log('ERROR: ' + error);
            });
          } else {
            this.axios.delete('/admin/exclude-tc/'+memberPlayer.playerId)
            .then(function (response) {
              console.log("SUCCESS: " + response.data);
            })
            .catch(function (error) {
              console.log('ERROR: ' + error);
            });
          }
        },
        save: function(player) {
            this.axios.post('/admin/players/save', player)
            .then(function (response) {
              swal("Success", "Player saved.", "info");
            })
            .catch(function (error) {
              console.log('ERROR: ' + error);
              swal("Error", "Save player failed.", "error");
            });
        },
        resetPassword(player) {
          player.password = null;
        },
        handleFileUpload(event, memberPlayer){
          this.file = event.target.files[0];
          this.showButton = true;
          this.selectPlayerId = memberPlayer.player.playerId;
        },
        uploadPlayerImaged(memberPlayer, idx) {
          var _this = this;
          var _memberPlayer = memberPlayer;

          let formData = new FormData();

          console.log(idx);

          formData.append('file', this.file);

          console.log('/admin/images/players/load/' + this.file.name);

          var fileName = _memberPlayer.player.firstName + '-' + _memberPlayer.player.lastName + '.png';

          this.axios.post( '/admin/images/players/load/' + fileName,
            formData,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
          ).then(function() {
            document.getElementById("choose-playerfile-id").value = "";
            _this.showButton = false;
            _memberPlayer.player.photoName = fileName;
            _this.save(_memberPlayer.player);

             swal("Success", "Image uploaded successfully.", "info")
             .then((willDelete) => {
                console.log("UPD: " + willDelete);
             });
            console.log('SUCCESS!!');
          })
          .catch(function(error){
            swal("Problem", "Unable to load image.", "error");
            console.log('FAILURE!! ' + error);
          });
        }
      }
    }

</script>

<style scoped>
  a {
    text-align: right;
    margin-bottom: 10px;
  }

  select {
    margin-right: 10px;
  }

  .checkbox {
    height: 20px;
    width: 20px;
  }
  .flex-container {
    display: flex;
  }

  .flex-container > div {
    display: inline-block;
    margin-right: 5px;
    vertical-align: top;
  }

  .input-text {
    width: 60px;
    border: 1px solid black;
    border-radius: 5px;
    padding: 3px 3px !important;
  }

  .actionBtns {
    width: 100%;
  }

  .player-div {
    display: inline-block;
    margin-bottom: 10px !important;
  }

  .btnAction {
    display: inline-block;
    font-size: 14px !important;
    float: left;
    margin-right: 10px;
  }

  .label {
    font-size: 12px;
    font-weight: bold;
    display: inline-block;
    width: 100px;
  }

  .player-subcard {
    display: inline-block;
    width: 48% !important;
    height: 170px;
    vertical-align: top;
  }

  .player-card {
    display: inline-block;
    margin-bottom: 7px !important;
    padding: 7px;
    width: 100% !important;
  }

  .player-card * {
    font-size: 12px !important;
  }

  .player-image-div {
    border-radius: 5px;
    margin-bottom: 10px;
    width: 100%;
  }

  .player-img, member-logo {
    display: inline-block;
    margin-right: 7px;
  }

  .player-img {
    max-height: 140px;
    max-width: 100px;
  }

  .player-subcard span {
    display: inline-block;
    margin-right: 5px;
  }

  .player-subcard .label12 {
    margin-bottom: 10px;
  }

  .player-content {
    margin: 7px 10px !important;
    height: 28px;
  }

  .actions-card {
    display: inline-blcok;
    width: 100%;
    height: 40px;
  }

  .noShow {
    display: none;
  }

  @media (min-width: 768px) {

    .player-card {
      padding: 10px;
      width: 100%;
      height: 260px;
      min-width: 1320px;
    }

    .player-subcard {
      float: left;
      padding: 5px;
      width: 260px !important;
    }

    .player-content {
      width: 240px;
      height: 28px;
    }
  }

  .member-logo {
    display: inline-block;
    height: 30px;
    width: 30px;
    border-radius: 45px;
    margin-left: 5px;
  }

</style>